import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { DirectivesModule } from "src/app/directives/directives.module";
import { QuestionsModule } from "../../questions/questions.module";
import { SharedModule } from "../../shared/shared.module";
import { ApgQuickQuoteCriticalIllnessComponent } from "./apg-quick-quote-critical-illness.component";
import { CurrentQuoteComponent } from "./current-quote/current-quote.component";
import { CustomQuoteComponent } from "./custom-quote/custom-quote.component";
import { QuickQuoteCIHelper } from "./quick-quote-ci.helper";
import { QuoteOptionComponent } from "./quote-option/quote-option.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DirectivesModule,
    NgxSliderModule,
    CurrencyMaskModule,
    SharedModule,
    QuestionsModule
  ],
  providers: [
    CurrencyPipe,
    QuickQuoteCIHelper
  ],
  exports: [
    ApgQuickQuoteCriticalIllnessComponent
  ],
  declarations: [
    ApgQuickQuoteCriticalIllnessComponent,

    QuoteOptionComponent,
    CurrentQuoteComponent,
    CustomQuoteComponent
  ]
})
export class ApgQuickQuoteCriticalIllnessModule { }

